import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import SelectTemplate from "./SelectTemplate.vue";
import CreateInstance from "@/components/ConfigTemplates/CreateInstance.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateUserObjectStore',
    setup(__props) {
        const loadingTemplatesInfoMessage = "Loading storage location templates";
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.ensureTemplates();
        const templates = computed(() => objectStoreTemplatesStore.latestTemplates);
        const loading = computed(() => objectStoreTemplatesStore.loading);
        const router = useRouter();
        async function chooseTemplate(selectTemplateId) {
            router.push({
                path: `/object_store_templates/${selectTemplateId}/new`,
            });
        }
        return { __sfc: true, loadingTemplatesInfoMessage, objectStoreTemplatesStore, templates, loading, router, chooseTemplate, SelectTemplate, CreateInstance };
    }
});
